import React from "react";
import TitleImg from '../../img/titleimg.png'
import headingIcon1 from '../../img/heading-icon-1.png'
import headingIcon2 from '../../img/heading-icon-2.png'
import headingIcon3 from '../../img/heading-icon-3.png'
import RightCircleImg from '../../img/rightcircle.png'
import LeftGraph from '../../img/left-graph.png'
import RightGraph from '../../img/right-graph.jpg'
import { Link, useLocation } from "react-router-dom";
import EditPencil from '../../img/pencil_edit_icon.png'
import useFetch from "../../hooks/useFetch";
import { useState } from "react";
import { useEffect } from "react";
export default function TspSupplierReportFinalData() {

  const { state } = useLocation();

  const { data, isLoading } = useFetch(`tsp/getAllTspDetails/?id=${state}`);

  const [tabledata, setTableData] = useState({
    GHGEmissionsTotals: [],
    Wastemeasuredandtrended: [],
    Watermeasuredandtrended: [],
    Energymeasuredandtrended: [],
  });


  const pushdata = () => {
    if (data.data && Object.keys(data.data).length > 0) {
      data.data.map((cdata) => {
        if (cdata.Questions === "Total Scope 1 GHG Emissions" || cdata.Questions === "Total Scope 2 GHG Emissions") {
          setTableData((prevData) => {
            if (!prevData.GHGEmissionsTotals.some(existingData => existingData.Questions === cdata.Questions)) {
              return {
                ...prevData,
                GHGEmissionsTotals: [...prevData.GHGEmissionsTotals, cdata],
              };
            }
            return prevData;
          });
        }

        if (cdata.Questions === "Total Hazardous Waste" || cdata.Questions === "Total Non-Hazardous Waste" || cdata.Questions === "Total Waste Recycled") {
          setTableData((prevData) => {
            if (!prevData.Wastemeasuredandtrended.some(existingData => existingData.Questions === cdata.Questions)) {
              return {
                ...prevData,
                Wastemeasuredandtrended: [...prevData.Wastemeasuredandtrended, cdata],
              };
            }
            return prevData;
          });
        }

        if (cdata.Questions === "Total Water withdrawn" || cdata.Questions === "Total Water discharged" || cdata.Questions === "Total Water recycled and reused") {
          setTableData((prevData) => {
            if (!prevData.Watermeasuredandtrended.some(existingData => existingData.Questions === cdata.Questions)) {
              return {
                ...prevData,
                Watermeasuredandtrended: [...prevData.Watermeasuredandtrended, cdata],
              };
            }
            return prevData;
          });
        }

        if (cdata.Questions === "Energy consumed") {
          setTableData((prevData) => {
            if (!prevData.Energymeasuredandtrended.some(existingData => existingData.Questions === cdata.Questions)) {
              return {
                ...prevData,
                Energymeasuredandtrended: [...prevData.Energymeasuredandtrended, cdata],
              };
            }
            return prevData;
          });
        }
      });
    }
  };

  const generateRandomDate = (year) => {
    const randomMonth = Math.floor(Math.random() * 12) + 1; // Random month between 1 and 12
    const daysInMonth = new Date(year, randomMonth, 0).getDate(); // Get the number of days in the random month
    const randomDay = Math.floor(Math.random() * daysInMonth) + 1; // Random day between 1 and the number of days in the month

    // Format the date as "YYYY-MM-DD"
    const formattedDate = `${year}-${randomMonth.toString().padStart(2, '0')}-${randomDay.toString().padStart(2, '0')}`;

    return formattedDate;
  };


  useEffect(() => {
    pushdata();
  }, [data]);

  const rightDottedBorder = {
    borderRight: '2px dotted #444',
  };

  return (
    <>
      <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
          <h1 className="h2">
            <a href="/tspsupplierreportfinal"><i class="fa-solid fa-arrow-left"></i></a>
            TSP Supplier Report Data</h1>
        </div>

        <div className="tspsupplierreportfinal">

          <div className="row reportheader">
            <div className="col-sm-8" style={rightDottedBorder}>
              <div className="row justify-content-center">
                <div className="reportheading">
                  <img src={TitleImg} />
                  <h1>
                    {data.seller} - Vistra (Demo) <span>ESG/Environmental Practices</span>
                    <small>{generateRandomDate(data.year)}</small>
                  </h1>

                </div>
              </div>
              <div className="row justify-content-center">
                <div className="headingicons justify-content-center">
                  <div className="headingicon">
                    <img src={headingIcon1} />
                    <span>formalized ESG strategy</span>
                  </div>
                  <div className="headingicon">
                    <img src={headingIcon2} />
                    <span>tracking environmental metrics</span>
                  </div>
                  <div className="headingicon">
                    <img src={headingIcon3} />
                    <span>reporting data publicly</span>
                  </div>
                  <div className="headingicon">
                    <img src={headingIcon2} />
                    <span>communicated environmental targets</span>
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="reportaddress">
                  <span>Contact Information</span>
                  <span> tsp+{data.seller}@djaodjin.com </span>
                  <span> 51060555555 </span>
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <img src={RightCircleImg} />
            </div>
          </div>
          <div className="row section1">
            <div className="col-sm-12">
              <h2>Environmental, Social and Governance (ESG)Core</h2>
            </div>
            <div className="col-sm-6">
              <img src={LeftGraph} />
            </div>
            <div className="col-sm-6">
              <img src={RightGraph} />
            </div>
            <div className="col-sm-12">
              <p>Benchmarking is based on responses from ? companies responding on practices in the industry segment</p>
            </div>
          </div>
          <div className="section2">
            <div className="row">
              <div className="col-sm-12">
                <div className="headingicontext">
                  <img src={headingIcon2} />
                  <h3>ESG Core questions</h3>
                </div>
              </div>
            </div>
            <div className="section3">
              <div className="row">
                <div className="col-sm-8">
                  <div className="left-content">
                    <h4>Environment, Social & Governance (ESG) Strategy</h4>
                    <div className="content-list">
                      <p>(1)Does your company have a formalized ESG strategy and performance targets that: 1/ Deﬁne a future vision of ESG performance, 2/ Are clear, actionable, and achievable, 3/ Are resourced eﬀectively, 4/ Address material issues for the business?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                        <Link>external link</Link>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(1a) If yes, Has your company assigned formal responsibility for directing and overseeing ESG performance to top/executive management?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(1c)  If yes, Does your company report internally, including to top management, on strategy: key No ESG issues (revealed by materiality analysis), resiliency, risk, business continuity, progress toward
                        goals, and plans/needs to address gaps towards your targets?</p>
                      <div className="right-ans">
                        <span>No</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(1d)  If yes, Does your company report externally on strategy: program elements, key ESG issues and goals, challenges, resiliency, and continual improvement eﬀorts in accordance with a reputable reporting standard (e.g. GRI, SASB, TCFD)?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(1e)  If yes, Does your company have ESG strategy and reports, targets, and Key Performance Indicators (KPIs) periodically (every 5 years or sooner) validated by an independent third party?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>Environment, Social & Governance (ESG) Materiality Assessment</h4>
                    <div className="content-list">
                      <p>(2)  Has your company conducted a systematic, rigorous assessment to identify and prioritize material ESG impacts, issues and opportunities?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>Code of conducts and policies</h4>
                    <div className="content-list">
                      <p>(3)Does your company have an Employee Code of Conduct in place? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(3)Does your company have a Supplier Code of Conduct and/or Human Rights Policy in place? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>Sourcing practices</h4>
                    <div className="content-list">
                      <p>(5)Are there any conﬂict minerals or additional minerals of concern (including: cobalt, tin, tantalum, tungsten, or gold) in the product(s) that your company manufactures, subcontracts, or sells? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(5a) If yes - Has your company published a due diligence report on conﬂict minerals (including or not including cobalt)?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(6) Does your company have a policy related to sourcing minerals of concern?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                        <span className="commentplease">Please Comment...</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(7) Does your company source any of the speciﬁc materials, minerals, or products from the related countries listed on the Department of Labor "List of Goods Produced by Child Labor or Forced Labor" (available here https://www.dol.gov/agencies/ilab/reports/child-labor/list-of-goods)?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(8) Does your company have a policy related to sourcing materials from regions of concern? </p>
                      <div className="right-ans">
                        <span>No</span>
                      </div>
                    </div>
                    <h4>Environmental Management System Rigor</h4>
                    <div className="content-list">
                      <p>(9) Has your company implemented an environmental management system that conforms with a No recognized international (e.g. ISO 14001) or local standard?</p>
                      <div className="right-ans">
                        <span>No</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(9a) Is the system certiﬁed to a recognized local or international standard?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(9b)  Is the system periodically (e.g. every 5 years) audited internally and by an independent third party?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>Environmental reporting</h4>
                    <div className="content-list">
                      <p>(10)  Has your company received or been responsible for a Notice of Violation (NOV), Consent Order or ﬁne over USD $10,000 from an environmental agency, or an environmental event that required reporting to an environmental agency in the past 36 months?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>GHG Emissions reporting</h4>
                    <div className="content-list">
                      <p>(11)  Does your company report total Scope 1 GHG emissions publicly?  </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(11a) Have Scope 1 GHG Emissions data been third-party veriﬁed within last 2 years? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(12)  Does your company report total Scope 2 GHG emissions publicly?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(12a)  Have Scope 2 GHG emissions data been third-party veriﬁed within last 2 years?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(15)  Does your company report total Scope 3 GHG emissions publicly?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(13a)  Have Scope 3 GHG emissions data been third-party veriﬁed within last 2 years?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>Water reporting</h4>
                    <div className="content-list">
                      <p>(14)  Does your company report water withdrawn, discharged and re-used publicly? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(14a)  Have water data been third-party veriﬁed within the last 2 years?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>Waste reporting</h4>
                    <div className="content-list">
                      <p>(13)  Does your company report waste generated and recycled publicly? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(15a)  Has the waste measurement methodology been third-party veriﬁed within the last 2 years?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>Energy</h4>
                    <div className="content-list">
                      <p> Does your company report total Energy consumed publicly? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>Have Energy data been third-party veriﬁed within last 2 years?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>Social & Governance reporting</h4>
                    <div className="content-list">
                      <p>(16) Has your company had any signiﬁcant code of conduct breaches including but not limited to breaches resulting in ﬁnes, class action lawsuits, or repeated breaches of Codes of Conduct in the past 36 months? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <h4>(17) Does your company report internally or externally Key Performance Indicators (KPIs) on ...</h4>
                    <div className="content-list">
                      <p>... Discrimination & Harassment?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Diversity of Employees?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Diversity of Executive Leadership and/or Board?</p>
                      <div className="right-ans">
                        <span>No</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Recordable Incident Rate? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Lost-time Case Rate?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Days Away, Restricted, and Transfer (DART) Rate?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Work-related Fatalities?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(18) Does your company have a target for diverse spend publicly communicated?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                        <span className="commentplease">Please Comment...</span>
                      </div>
                    </div>
                    <h4>(18a) If your company has a target for diverse spend, does your company deﬁne diverse suppliers as ...</h4>
                    <div className="content-list">
                      <p>... disability-owned businesses?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... HUBZone businesses? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... LGBT-owned businesses? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... minority-owned businesses?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... service-disable veteran businesses?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... small businesses (by revenue)? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... small businesses (by employees)?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>

                    <div className="content-list">
                      <p>... small disadvantaged businesses?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... veteran-owned businesses? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... woman-owned businesses?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>(18b) If your company has a target for diverse spend, does your company require third-party certiﬁcation to verify a supplier diverse status?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>

                  </div>

                </div>

              </div>
              <div className="row">
                <div className="col-sm-12">
                  <div className="headingicontext">
                    <img src={EditPencil} />
                    <h3>ESG informative details</h3>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-8">
                  <div className="left-content">
                    <h4>Management System Rigor</h4>
                    <div className="content-list">
                      <p>(9c) Please indicate the coverage of the environmental management system across your business and/or facilities (e.g. % of owned facilities with an ISO 14001 certiﬁcate)?</p>
                      <div className="right-ans">
                        <span className="pcent">7%</span>

                      </div>
                    </div>
                    <div className="content-list">
                      <p>(4a) Percentage of targeted suppliers that have signed the Supplier Code of Conduct?</p>
                      <div className="right-ans">
                        <span className="pcent">10%</span>

                      </div>
                    </div>
                    <div className="content-list">
                      <p>(4b) What is the percentage of targeted suppliers with contracts that include clauses on environmental, labor, and human rights requirements?</p>
                      <div className="right-ans">
                        <span className="pcent">5%</span>

                      </div>
                    </div>
                    <h4>(3b) Does your company's Employee Code of Conduct contain sections pertinent to ...</h4>
                    <div className="content-list">
                      <p>... Child and Forced Labor?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Corruption and bribery? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Discrimination & harassment?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Diversity and inclusion? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Working hours?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Conﬁdentiality of information?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Conﬂicts of interest? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Antitrust/anti-competitive practices? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Money-laundering and/or insider trading/dealing?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Environment, health and safety?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Whistleblowing?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Collective bargaining, labor unions?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>

                    <h4>(4d) Does your company’s Supplier Code of Conduct and/or Human Rights Policy contain sections pertinent to ...</h4>
                    <div className="content-list">
                      <p>... Child and Forced Labor?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Corruption and bribery? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Discrimination & harassment?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Diversity and inclusion? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Working hours?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Conﬁdentiality of information?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Conﬂicts of interest? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Antitrust/anti-competitive practices? </p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Money-laundering and/or insider trading/dealing?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Environment, health and safety?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Whistleblowing?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>
                    <div className="content-list">
                      <p>... Collective bargaining, labor unions?</p>
                      <div className="right-ans">
                        <span>Yes</span>
                      </div>
                    </div>

                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="headingicontext">
                    <img src={headingIcon2} />
                    <h3>Data & metrics</h3>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-8">
                  <div className="left-content">
                    {data.data && Object.keys(data).length > 0 ? (
                      data.data.map((curData) => (
                        <div key={curData.id}>
                          {curData.Questions === "Reporting Organization's Annual Gross Revenue" ? (
                            <div>
                              <h4>General information</h4>
                              <div className="content-list">
                                <p>Reporting Organization's Annual Gross Revenue</p>
                                <div className="right-ans" style={{ paddingLeft: '0px' }}>
                                  <span className="pcent">
                                    {curData.Assessed} Millions US Dollars ($M)
                                  </span>
                                </div>
                              </div>
                            </div>
                          ) : null}

                          {curData.Questions === "Reporting organization's Full-time Employee Count" ? (
                            <div className="content-list">
                              <p>Reporting organization's Full-time Employee Count</p>
                              <div className="right-ans" style={{ paddingLeft: '0px' }}>
                                <span className="pcent">{curData.Assessed} employees</span>
                              </div>
                            </div>
                          ) : null}
                        </div>
                      ))
                    ) : (
                      <span>No Tsp supplier reports data available.</span>
                    )}

                    <h4>Water measured and trended</h4>
                    <h4>GHG Emissions Totals</h4>
                    <div className="reporttables">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">{data.year}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            tabledata.GHGEmissionsTotals && tabledata.GHGEmissionsTotals.length > 0 ? (tabledata.GHGEmissionsTotals.map((curData, index) => {

                              return (
                                <tr key={index}>
                                  <th scope="row">{curData.Questions}</th>
                                  <td>{curData.Assessed}</td>
                                </tr>
                              )
                            })
                            ) : (
                              <span>No data available.</span>
                            )
                          }
                        </tbody>
                      </table>
                      <span>Metric Tons / Year </span>
                    </div>

                    <div>
                      <h4 className="mt-3">Waste measured and trended</h4>
                      <div className="reporttables">
                        <table className="table table-bordered">
                          <thead>
                            <tr>
                              <th scope="col"></th>
                              <th scope="col">{data.year}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {
                              tabledata.Wastemeasuredandtrended && tabledata.Wastemeasuredandtrended.length > 0 ? (tabledata.Wastemeasuredandtrended.map((curData, index) => {

                                return (
                                  <tr key={index}>
                                    <th scope="row">{curData.Questions}</th>
                                    <td>{curData.Assessed}</td>
                                  </tr>
                                )
                              })
                              ) : (
                                <span>No data available.</span>
                              )
                            }
                          </tbody>
                        </table>
                        <span>Metric Tons / Year </span>
                      </div>
                    </div>

                    <h4 className="mt-3">Water measured and trended</h4>
                    <div className="reporttables">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">{data.year}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            tabledata.Watermeasuredandtrended && tabledata.Watermeasuredandtrended.length > 0 ? (tabledata.Watermeasuredandtrended.map((curData, index) => {

                              return (
                                <tr key={index}>
                                  <th scope="row">{curData.Questions}</th>
                                  <td>{curData.Assessed}</td>
                                </tr>
                              )
                            })
                            ) : (
                              <span>No data available.</span>
                            )
                          }

                        </tbody>
                      </table>
                      <span>Gallons / Year </span>
                    </div>

                    <h4 className="mt-3">Energy measured and trended</h4>
                    <div className="reporttables">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th scope="col"></th>
                            <th scope="col">{data.year}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            tabledata.Energymeasuredandtrended && tabledata.Energymeasuredandtrended.length > 0 ? (tabledata.Energymeasuredandtrended.map((curData, index) => {

                              return (
                                <tr key={index}>
                                  <th scope="row">{curData.Questions}</th>
                                  <td>{curData.Assessed}</td>
                                </tr>
                              )
                            })
                            ) : (
                              <span>No data available.</span>
                            )
                          }

                        </tbody>
                      </table>
                      <span>Kilowatt-hour (kWh) / Period </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="headingicontext">
                    <img src={headingIcon2} />
                    <h3>Targets</h3>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-8">
                  <div className="left-content">
                    <h4>GHG Emissions Target</h4>
                    <h4>(17) Scope 1 GHG Emissions Target</h4>
                    <div className="content-list">
                      <p>When do you expect to achieve your Scope 1 GHG Emissions target? (Please describe the target, or why you do not have a target, in comments)</p>
                      <div className="right-ans">
                        <span >2022</span>

                      </div>
                    </div>
                    <div className="content-list">
                      <p>Is this a science-based target, net-zero target, or other? </p>
                      <div className="right-ans">
                        <span >Net Zero</span>

                      </div>
                    </div>
                    <h4>(18) Scope 2 GHG Emissions Target</h4>
                    <div className="content-list">
                      <p>When do you expect to achieve your Scope 2 GHG Emissions target? (Please describe the target, or why you do not have a target, in comments)</p>
                      <div className="right-ans">
                        <span >2027</span>

                      </div>
                    </div>
                    <div className="content-list">
                      <p>Is this a science-based target, net-zero target, or other? </p>
                      <div className="right-ans">
                        <span >Net Zero</span>

                      </div>
                    </div>
                    <h4>(18) Scope 3 GHG Emissions Target</h4>
                    <div className="content-list">
                      <p>When do you expect to achieve your Scope 3 GHG Emissions target? (Please describe the target, or why you do not have a target, in comments)</p>
                      <div className="right-ans">
                        <span >2028</span>

                      </div>
                    </div>
                    <div className="content-list">
                      <p>Is this a science-based target, net-zero target, or other? </p>
                      <div className="right-ans">
                        <span >Net Zero</span>

                      </div>
                    </div>
                    <h4>Water Use Target</h4>
                    <div className="content-list">
                      <p>When do you expect to achieve your water use target? (Please describe the target, or why you do not have a target, in comments) </p>
                      <div className="right-ans">
                        <span >2025</span>

                      </div>
                    </div>
                    <h4>Waste Reduction Target</h4>
                    <div className="content-list">
                      <p>When do you expect to achieve your waste reduction target? (Please describe the target, or why you do not have a target, in comments)</p>
                      <div className="right-ans">
                        <span >2029</span>

                      </div>
                    </div>
                    <h4>Energy Target</h4>
                    <div className="content-list">
                      <p>When do you expect to achieve your energy reduction target? (Please describe the target, or why you do not have a target, in comments)</p>
                      <div className="right-ans">
                        <span >2029</span>

                      </div>
                    </div>
                    <h4>Diverse spend and/or representation</h4>
                    <div className="content-list">
                      <p>When do you expect to achieve your diverse spend and/or representation target? (Please describe the target, or why you do not have a target, in comments)</p>
                      <div className="right-ans">
                        <span >2030</span>

                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </main>
    </>
  );
}
